/* eslint-disable react/prop-types */
import React from 'react';

// Toggleable pill used in three places, each with its own scoped styling:
//  • variant="tab"   → radar hub tabs (orange when active)
//  • variant="range" → 7/10-day forecast chips (orange when active)
//  • variant="layer" → radar layer toggles (blue when active)
const VARIANT_CLASS = {
  tab: 'radar-tab',
  range: 'forecast-chip',
  layer: 'layer-chip',
};

const PillToggle = ({ variant = 'tab', active, onClick, children }) => (
  <span
    className={`${VARIANT_CLASS[variant] || VARIANT_CLASS.tab}${
      active ? ' active' : ''
    }`}
    role="button"
    tabIndex={0}
    aria-pressed={!!active}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(e);
      }
    }}
  >
    {children}
  </span>
);

export default PillToggle;
